export { default } from "./QueryModalTrigger";
export * from "./QueryModalTrigger";
